// ── ID Card — CR80 Portrait (54 × 85.6 mm) ───────────────────────
// Rendered at 2× for screen: 404 × 638 px

// Format DOB to dd-mm-yyyy regardless of input format
function fmtDob(dob) {
  if (!dob) return '—';
  if (/^\d{2}-\d{2}-\d{4}$/.test(dob)) return dob;
  if (/^\d{4}-\d{2}-\d{2}$/.test(dob)) {
    const [y, m, d] = dob.split('-');
    return `${d}-${m}-${y}`;
  }
  const dt = new Date(dob);
  if (!isNaN(dt)) {
    const d = String(dt.getDate()).padStart(2, '0');
    const m = String(dt.getMonth() + 1).padStart(2, '0');
    return `${d}-${m}-${dt.getFullYear()}`;
  }
  return dob;
}

const GFONT = `@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700;800;900&family=Roboto:wght@300;400;500;700&family=Roboto+Mono:wght@400;500&family=Raleway:wght@300;400;600&family=Cormorant+Garamond:wght@400;500;600&display=swap');`;

const THEMES = {
  blue:   { h1: '#0d2b6e', h2: '#1749b1', acc: '#f0c040', bg: '#eef2fb' },
  green:  { h1: '#064e3b', h2: '#059669', acc: '#6ee7b7', bg: '#edfaf4' },
  maroon: { h1: '#6b0f0f', h2: '#b91c1c', acc: '#fca5a5', bg: '#fdf2f2' },
  navy:   { h1: '#0f172a', h2: '#1e3a5f', acc: '#93c5fd', bg: '#eff4fb' },
  purple: { h1: '#3b0764', h2: '#7c3aed', acc: '#ddd6fe', bg: '#f5f0ff' },
};

const CW = 404;
const CH = 638;
export const CARD_DIMS = { CW, CH };

function buildCardFront(s, photo, logo, phone, year, prin, theme) {
  const th = THEMES[theme] || THEMES.blue;
  const dob = fmtDob(s.dob);
  const mob = s.fphone || s.ph || '—';

  const photoEl = photo
    ? `<img src="${photo}" style="width:100%;height:100%;object-fit:cover;display:block;">`
    : `<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:#e8edf5;font-size:44px;font-weight:900;color:#aab4cc;font-family:sans-serif;">${((s.fn||'?')[0]).toUpperCase()}</div>`;

  let qrEl = '';
  try {
    const qd = encodeURIComponent(`${s.fn||''} ${s.ln||''}\nClass:${s.cls||''} Roll:${s.roll||''}\nAdm:${s.admno||''}\nFather:${s.father||''}\nPh:${mob}`);
    qrEl = `<img src="https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${qd}&margin=3&ecc=M" width="135" height="135" style="display:block;" alt="QR"/>`;
  } catch(e){}

  const drow = (label, val) =>
    `<div style="margin-bottom:18px;"><div style="font-size:13px;color:#444;font-family:'Roboto',sans-serif;">${label}</div><div style="font-size:18px;font-weight:700;color:#111;font-family:'Montserrat',sans-serif;line-height:1.2;">${val}</div></div>`;

  const logoEl = logo
    ? `<img src="${logo}" style="width:86px;height:86px;object-fit:contain;display:block;">`
    : `<div style="width:86px;height:86px;display:flex;align-items:center;justify-content:center;font-size:48px;">🏫</div>`;

  return `<div style="width:${CW}px;height:${CH}px;border-radius:10px;overflow:hidden;box-shadow:0 16px 48px rgba(0,0,0,.4);display:flex;flex-direction:column;background:${th.bg};font-family:'Montserrat',sans-serif;">
<style>${GFONT} * { margin:0; padding:0; box-sizing:border-box; }</style>

<!-- Header: logo | divider | school name -->
<div style="background:#fff;padding:16px 16px;display:flex;align-items:center;gap:14px;border-bottom:3px solid ${th.h1};">
  ${logoEl}
  <div style="width:2px;height:72px;background:#ddd;flex-shrink:0;"></div>
  <div style="flex:1;">
    <div style="font-size:26px;font-weight:900;color:${th.h1};font-family:'Montserrat',sans-serif;text-transform:uppercase;line-height:1.05;letter-spacing:0.3px;">Lord Krishna</div>
    <div style="font-size:26px;font-weight:900;color:${th.h1};font-family:'Montserrat',sans-serif;text-transform:uppercase;line-height:1.05;letter-spacing:0.3px;margin-bottom:6px;">Public School</div>
    <div style="font-size:14px;color:${th.h1};font-family:'Cormorant Garamond',serif;font-weight:600;margin-bottom:1px;letter-spacing:0.4px;">Govt. Recognised</div>
    <div style="font-size:14px;color:${th.h1};font-family:'Cormorant Garamond',serif;font-weight:600;margin-bottom:1px;letter-spacing:0.4px;">Ishapur, Laxminagar, Mathura</div>
  </div>
</div>

<!-- "Student ID Card" bar -->
<div style="background:${th.bg};padding:8px 0;text-align:center;border-bottom:1px solid rgba(0,0,0,.08);">
  <span style="font-size:15px;font-weight:600;color:#333;font-family:'Montserrat',sans-serif;letter-spacing:1.5px;">Student ID Card</span>
</div>

<!-- Dark name bar -->
<div style="background:${th.h1};padding:10px 14px;text-align:center;">
  <span style="font-size:20px;font-weight:300;color:#fff;font-family:'Raleway',sans-serif;letter-spacing:2px;text-transform:uppercase;">${s.fn||'Student'} ${s.ln||''}</span>
</div>

<!-- Body -->
<div style="flex:1;display:flex;background:${th.bg};min-height:0;">
  <div style="width:165px;flex-shrink:0;padding:14px 10px 14px 14px;display:flex;flex-direction:column;align-items:flex-start;">
    <div style="width:155px;height:190px;overflow:hidden;border:3px solid ${th.h1};border-radius:6px;flex-shrink:0;box-shadow:0 4px 12px rgba(0,0,0,.2);">${photoEl}</div>
    <div style="flex:1;min-height:8px;"></div>
    ${qrEl}
  </div>
  <div style="flex:1;padding:16px 14px 14px;display:flex;flex-direction:column;min-width:0;">
    ${drow('Class / Section:', s.cls||'—')}
    ${drow('Date of Birth:', dob)}
    ${drow('Validity:', year||'2025-2026')}
    ${s.admno ? drow('Adm. No.:', s.admno) : drow('Roll No.:', s.roll||'—')}
    ${s.blood ? drow('Blood Group:', `<span style="color:#c0392b;">${s.blood}</span>`) : ''}
    <div style="margin-top:auto;text-align:right;padding-top:6px;">
      <div style="font-size:24px;font-style:italic;color:${th.h1};font-family:'Georgia',serif;">${prin||'__________'}</div>
      <div style="font-size:12px;color:#555;font-family:'Roboto',sans-serif;margin-top:3px;">Principal</div>
    </div>
  </div>
</div>

<!-- Footer -->
<div style="background:${th.h1};padding:8px 14px;text-align:center;">
  <span style="font-size:12px;color:rgba(255,255,255,.85);font-family:'Roboto',sans-serif;letter-spacing:1px;font-weight:500;">www.lkpschool.in</span>
</div>
</div>`;
}

export function buildCardBack(s, logo, phone) {
  const mob = s.fphone || s.ph || '—';
  const addr = [s.addr, s.city, s.pin ? 'Pin-'+s.pin : ''].filter(v => v && v !== 'admin').join(', ') || '—';

  const infoRow = (label, val) =>
    `<div style="display:flex;align-items:baseline;gap:6px;margin-bottom:9px;">
      <div style="font-size:13px;color:#222;font-family:'Roboto',sans-serif;white-space:nowrap;">${label}</div>
      <div style="font-size:14px;font-weight:700;color:#000;font-family:'Montserrat',sans-serif;flex:1;line-height:1.4;">${val}</div>
    </div>`;

  return `<div style="width:${CW}px;height:${CH}px;border-radius:10px;overflow:hidden;font-family:'Montserrat',sans-serif;box-shadow:0 16px 48px rgba(0,0,0,.45);display:flex;flex-direction:column;background:#fff;">
<style>${GFONT}</style>
<div style="padding:16px 16px 12px;display:flex;flex-direction:column;">
  ${s.blood ? infoRow('Blood Group :', `<span style="font-size:15px;font-family:'Montserrat',sans-serif;color:#c0392b;">${s.blood}</span>`) : ''}
  ${s.ph ? infoRow('Alt. Contact No. :', s.ph) : ''}
  ${infoRow("Father's Name :", s.father||'—')}
  ${infoRow("Mother's Name :", s.mother||'—')}
  ${s.fphone ? infoRow("Father's Contact No :", s.fphone) : ''}
  <div style="margin-bottom:4px;font-size:13px;color:#222;font-family:'Roboto',sans-serif;">Address :</div>
  <div style="font-size:13px;font-weight:700;color:#000;font-family:'Montserrat',sans-serif;line-height:1.55;margin-bottom:14px;">${addr}</div>
  <div style="font-size:13px;font-weight:700;color:#000;text-decoration:underline;margin-bottom:7px;font-family:'Roboto',sans-serif;">Rules to be followed :</div>
  <div style="font-size:11.5px;color:#111;line-height:1.85;font-family:'Roboto',sans-serif;">
    <div style="margin-bottom:2px;">• This card must be carried by the student at all times within school premises.</div>
    <div style="margin-bottom:2px;">• If found, please return this card to the school office.</div>
    <div style="margin-bottom:2px;">• Loss of ID card must be reported to the class teacher immediately.</div>
    <div style="margin-bottom:2px;">• A fine will be charged for re-issuance of a lost card.</div>
    <div>• Misuse of this card is a punishable offence as per school discipline policy.</div>
  </div>
</div>
<div style="flex:1;background:#fff;"></div>
<div style="height:150px;background:#fff;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;flex-shrink:0;overflow:hidden;">
  ${logo
    ? `<img src="${logo}" style="height:100px;object-fit:contain;opacity:0.45;">`
    : `<div style="font-size:80px;opacity:0.35;line-height:1;">🏫</div>`}
  <div style="font-size:17px;font-weight:800;color:#ccc;font-family:'Montserrat',sans-serif;letter-spacing:1px;text-transform:uppercase;">Lord Krishna Public School</div>
</div>
<div style="background:#111;padding:14px 14px;text-align:center;flex-shrink:0;">
  <div style="font-size:12px;color:#ddd;font-family:'Roboto',sans-serif;line-height:1.7;">Ishapur, Laxminagar, Mathura - 281204 (UP) India</div>
  <div style="font-size:12px;color:#aaa;font-family:'Roboto Mono',monospace;margin-top:4px;">Phone: +91 9997360040, +91 8650616990</div>
</div>
</div>`;
}

export function buildCard(s, photo, logo, phone, year, prin, theme, big = true) {
  return buildCardFront(s, photo, logo, phone, year, prin, theme);
}

const printCSS = (single) => `
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:Arial,sans-serif;background:#cbd5e1;padding:${single?'24px':'14px'};display:flex;gap:28px;justify-content:center;flex-wrap:wrap;align-items:flex-start;}
  .side-label{font-size:9px;color:#64748b;text-align:center;margin-bottom:6px;font-weight:700;text-transform:uppercase;letter-spacing:.08em;font-family:Arial,sans-serif;}
  .card-wrap{transform:scale(0.51);transform-origin:top left;display:inline-block;line-height:0;}
  .side{display:flex;flex-direction:column;align-items:flex-start;width:${Math.round(CW*0.51)}px;height:${Math.round(CH*0.51)}px;}
  .pair{display:flex;gap:28px;margin-bottom:${single?'0':'24px'};justify-content:center;page-break-inside:avoid;align-items:flex-start;}
  @media print{body{background:#fff;padding:4mm;}.side-label{display:none;}.card-wrap{transform:scale(0.51);transform-origin:top left;}.pair{gap:8mm;}@page{margin:4mm;size:${single?'130mm 120mm':'A4 portrait'}}}
`;

export function printCard(s, photo, logo, phone, year, prin, theme) {
  const front = buildCardFront(s, photo, logo, phone, year, prin, theme);
  const back = buildCardBack(s, logo, phone);
  const w = window.open('', '_blank', 'width=820,height=620');
  w.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><style>${printCSS(true)}</style></head><body>
    <div class="pair">
      <div class="side"><div class="side-label">Front</div><div class="card-wrap">${front}</div></div>
      <div class="side"><div class="side-label">Back</div><div class="card-wrap">${back}</div></div>
    </div>
    <script>window.onload=()=>window.print()<\/script></body></html>`);
  w.document.close();
}

export function printClassCards(students, photos, logo, phone, year, prin, theme) {
  const pairs = students.map(s => {
    const front = buildCardFront(s, photos[s.id]||null, logo, phone, year, prin, theme);
    const back = buildCardBack(s, logo, phone);
    return `<div class="pair">
      <div class="side"><div class="side-label">Front</div><div class="card-wrap">${front}</div></div>
      <div class="side"><div class="side-label">Back</div><div class="card-wrap">${back}</div></div>
    </div>`;
  }).join('');
  const w = window.open('', '_blank');
  w.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><style>${printCSS(false)}</style></head><body>${pairs}<script>window.onload=()=>window.print()<\/script></body></html>`);
  w.document.close();
}


// ── Certificate header (used by CC) ──────────────────────────────
const certHeader = (school, addr, phone, logo) => {
  const logoImg = logo ? `<img src="${logo}" style="width:90px;height:90px;object-fit:contain;margin-bottom:10px;filter:drop-shadow(0 2px 6px rgba(0,0,0,.18));">` : `<span style="font-size:56px;margin-bottom:10px;display:block;">🏫</span>`;
  const safeAddr = (addr && addr.trim()) ? addr : 'Ishapur, Laxminagar, Mathura';
  return `<div style="text-align:center;border-bottom:2px solid #b8960c;padding-bottom:14px;margin-bottom:18px;">
    ${logoImg}
    <div style="font-family:'Playfair Display',serif;font-size:28px;font-weight:800;color:#1a2e5a;letter-spacing:0.8px;text-transform:uppercase;">${school}</div>
    <div style="font-family:'Inter',sans-serif;font-size:13px;font-weight:500;color:#555;margin-top:4px;">(Govt. Recognised)</div>
    <div style="font-family:'Inter',sans-serif;font-size:13.5px;font-weight:600;color:#333;margin-top:3px;">${safeAddr}${phone ? '  ·  Ph.: ' + phone : ''}</div>
  </div>`;
};

// ── Transfer Certificate ──────────────────────────────────────────
const tcCSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800&family=Inter:wght@300;400;500;600;700&display=swap');
*{box-sizing:border-box;margin:0;padding:0}
html,body{width:210mm;min-height:297mm;background:#fff;font-family:'Inter',sans-serif}
body{padding:5mm}
.cert{width:calc(210mm - 10mm);min-height:calc(297mm - 10mm);margin:0 auto;padding:10mm 12mm 10mm;border:2px solid #b8960c;position:relative;display:flex;flex-direction:column}
.cert::before{content:'';position:absolute;inset:10px;border:0.8px solid #d4b84a;pointer-events:none;z-index:0}
.logo-wm{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:280px;height:280px;object-fit:contain;opacity:0.04;pointer-events:none;z-index:0}
.content{position:relative;z-index:1;flex:1;display:flex;flex-direction:column}
.hdr{text-align:center;padding-bottom:10px;border-bottom:2px solid #b8960c;margin-bottom:10px}
.hdr-logo{width:88px;height:88px;object-fit:contain;margin-bottom:8px;filter:drop-shadow(0 2px 6px rgba(0,0,0,.18))}
.hdr-logo-ph{font-size:54px;margin-bottom:8px;display:block}
.hdr h1{font-family:'Playfair Display',serif;font-size:29px;font-weight:800;color:#1a2e5a;letter-spacing:0.8px;margin-bottom:4px;text-transform:uppercase}
.hdr .sub{font-family:'Inter',sans-serif;font-size:13px;font-weight:500;color:#555;margin-top:3px;letter-spacing:0.3px}
.hdr .sub-bold{font-family:'Inter',sans-serif;font-size:13.5px;font-weight:600;color:#333;margin-top:3px}
.ttl-box{background:#f7f2e8;border-top:2px solid #b8960c;border-bottom:2px solid #b8960c;padding:8px 0;margin:10px 0 12px;text-align:center}
.ttl-box span{font-family:'Playfair Display',serif;font-size:17px;font-weight:700;color:#1a2e5a;letter-spacing:3px;text-transform:uppercase}
.meta-row{display:flex;justify-content:space-between;font-size:13px;color:#444;margin-bottom:12px;font-weight:500;font-family:'Inter',sans-serif}
.meta-row strong{color:#1a2e5a;font-weight:700}
.rows{width:100%;border-collapse:collapse;font-size:13.5px;margin-bottom:4px}
.rows tr td{padding:5px 0;vertical-align:top;line-height:1.6}
.rows tr td.lbl{width:240px;color:#444;font-weight:400;padding-right:8px;white-space:nowrap;font-family:'Inter',sans-serif}
.rows tr td.sep{width:14px;text-align:center;color:#888;font-weight:300}
.rows tr td.val{font-weight:600;color:#1a1a2e;border-bottom:1px solid #ddd;font-family:'Inter',sans-serif;padding-bottom:4px}
.rows tr td.val.noln{border-bottom:none}
.cert-stmt{margin:14px 0;font-size:13px;color:#333;font-style:italic;line-height:1.7;font-family:'Inter',sans-serif}
.foot{margin-top:auto;padding-top:20px;display:flex;justify-content:space-between;align-items:flex-end;font-size:13px;font-family:'Inter',sans-serif}
.foot-left p{margin-bottom:6px;color:#444;font-weight:400}
.foot-left strong{color:#1a1a2e;font-weight:600}
.sign-block{text-align:center}
.sign-line{border-top:1.5px solid #1a2e5a;width:200px;margin-top:48px;padding-top:5px;font-weight:700;font-size:13.5px;color:#1a2e5a;font-family:'Inter',sans-serif;letter-spacing:0.5px}
.sign-sub{font-size:11.5px;margin-top:3px;color:#666}
@media print{html,body{width:210mm;height:297mm}.cert{border:2px solid #b8960c;width:calc(210mm - 10mm);min-height:calc(297mm - 10mm);padding:10mm 12mm}@page{margin:5mm;size:A4 portrait}head{display:none}}
`;

function tcBody(s, logo, sets, { tcNo, dt, admDt, ld, reason, conduct, feeStatus, attP, attT }) {
  const school  = sets.school || 'LORD KRISHNA PUBLIC SCHOOL';
  const addr    = (sets.addr && sets.addr.trim()) ? sets.addr : 'Ishapur, Laxminagar, Mathura';
  const phone   = sets.phone  || '';
  const dob     = fmtDob(s.dob);
  const attPct  = attT > 0 ? Math.round(attP / attT * 100) : 0;
  const stuAddr = [s.addr, s.city].filter(v => v && v !== 'admin').join(', ') || '—';
  const dobInWords = (() => {
    if (!s.dob) return '—';
    const d = new Date(s.dob);
    const day = d.getDate();
    const months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    const ones = ['','One','Two','Three','Four','Five','Six','Seven','Eight','Nine','Ten','Eleven','Twelve','Thirteen','Fourteen','Fifteen','Sixteen','Seventeen','Eighteen','Nineteen'];
    const tens = ['','','Twenty','Thirty','Forty','Fifty','Sixty','Seventy','Eighty','Ninety'];
    const numToWords = (n) => { if(n===0)return'Zero';if(n<20)return ones[n];if(n<100)return tens[Math.floor(n/10)]+(n%10?' '+ones[n%10]:'');return ones[Math.floor(n/100)]+' Hundred'+(n%100?' '+numToWords(n%100):''); };
    const year=d.getFullYear(),y1=Math.floor(year/100),y2=year%100;
    return `${numToWords(day)} ${months[d.getMonth()]} ${numToWords(y1)} Hundred${y2?' and '+numToWords(y2):''}`;
  })();
  const logoImg = logo ? `<img class="hdr-logo" src="${logo}">` : `<span class="hdr-logo-ph">🏫</span>`;
  const logoWm  = logo ? `<img class="logo-wm" src="${logo}">` : '';
  const row = (label, value, noUnderline = false) =>
    `<tr><td class="lbl">${label}</td><td class="sep">:</td><td class="val${noUnderline?' noln':''}">${value || '—'}</td></tr>`;
  return `<div class="cert">${logoWm}<div class="content">
    <div class="hdr">${logoImg}<h1>${school}</h1><div class="sub">(Govt. Recognised)</div><div class="sub-bold">${addr}${phone?'  ·  Ph.: '+phone:''}</div><div class="sub">UDISE: 09144100730</div>${sets.year?`<div class="sub">Academic Year : ${sets.year}</div>`:''}</div>
    <div class="ttl-box"><span>Transfer Certificate</span></div>
    <div class="meta-row"><span>Sl. No. : <strong>${tcNo||'—'}</strong></span><span>Date : <strong>${dt||'—'}</strong></span></div>
    <table class="rows">
      ${row('Name of Student',s.fn+' '+s.ln)}${row("Father's Name",s.father)}${row("Mother's Name",s.mother)}${row('Caste',s.caste)}${row('Religion',s.religion)}${row('Address',stuAddr)}${row('Date of Admission',admDt)}${row('Class',s.cls)}${row('Roll No.',s.roll)}${row('Admission No.',s.admno)}${s.pen?row('PEN No.',s.pen):''}${s.apaar?row('APAAR ID',s.apaar):''}${row('Date of Birth (as per register)',dob+(s.dob?`  <span style="font-weight:400;color:#555;font-size:11.5px">(${dobInWords})</span>`:''))}${s.blood?row('Blood Group',s.blood):''}${s.aadhar?row('Aadhaar No.',s.aadhar):''}${s.ps?row('Previous School',s.ps):''}${row('Character &amp; Conduct',conduct)}${row('Reason for Leaving',reason,true)}
    </table>
    <p class="cert-stmt">Certified that above scholar's register of leaving school has been filled up to date as per departmental rules.</p>
    <div class="foot"><div class="foot-left"><p>Date : <strong>${dt||'—'}</strong></p><p>Place : <strong>Mathura</strong></p></div><div class="sign-block"><div class="sign-line">Principal / Head Master</div><div class="sign-sub">${school}</div></div></div>
  </div></div>`;
}

export function buildTC(s, logo, sets, opts) {
  return `<style>${tcCSS}</style><body style="padding:0;background:#fff;">${tcBody(s, logo, sets, opts)}</body>`;
}
export function printTC(s, logo, sets, opts) {
  const w = window.open('', '_blank', 'width=820,height=1100');
  w.document.write(`<!DOCTYPE html><html><head><title>Transfer Certificate</title><style>${tcCSS}</style></head><body>${tcBody(s, logo, sets, opts)}<script>window.onload=()=>window.print()<\/script></body></html>`);
  w.document.close();
}

// ── Character Certificate ─────────────────────────────────────────
const ccCSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;1,400&family=Inter:wght@300;400;500;600;700&display=swap');
*{box-sizing:border-box;margin:0;padding:0}
html,body{width:210mm;min-height:297mm;background:#fff;font-family:'Inter',sans-serif}
body{padding:5mm}
.cert{width:calc(210mm - 10mm);min-height:calc(297mm - 10mm);margin:0 auto;padding:10mm 12mm;border:2px solid #b8960c;position:relative;display:flex;flex-direction:column}
.cert::before{content:'';position:absolute;inset:10px;border:0.8px solid #d4b84a;pointer-events:none;z-index:0}
.inner{position:relative;z-index:1;flex:1;display:flex;flex-direction:column}
.ttl{font-family:'Playfair Display',serif;font-size:24px;font-weight:700;color:#1a2e5a;text-align:center;margin:16px 0 4px;letter-spacing:2px;text-transform:uppercase}
.ttl-line{width:60px;height:2px;background:#b8960c;margin:0 auto 18px}
.no{text-align:right;font-size:14px;color:#555;margin-bottom:22px;font-weight:400}
.no b{color:#1a2e5a;font-weight:700}
.body{font-size:15px;line-height:2.2;color:#2a2a3a;text-align:justify;font-weight:400;flex:1}
.body b{color:#1a2e5a;font-weight:700}
.seal{display:flex;justify-content:space-between;align-items:flex-end;margin-top:auto;padding-top:24px}
.slk{text-align:center;min-width:160px}
.sll{font-size:14px;font-weight:700;color:#1a2e5a;margin-top:56px;border-top:1.5px solid #1a2e5a;padding-top:6px;font-family:'Inter',sans-serif;letter-spacing:0.5px}
@media print{html,body{width:210mm;height:297mm}.cert{border:2px solid #b8960c;width:calc(210mm - 10mm);min-height:calc(297mm - 10mm);padding:10mm 12mm}@page{margin:5mm;size:A4 portrait}}
`;

function ccBody(s, logo, sets, { ccNo, dt, conduct, purpose, remarks, attP, attT }) {
  const school = sets.school||'LORD KRISHNA PUBLIC SCHOOL', addr=(sets.addr && sets.addr.trim()) ? sets.addr : 'Ishapur, Laxminagar, Mathura', phone=sets.phone||'';
  const attPct = attT>0?Math.round(attP/attT*100):0;
  const attStr = attT>0?`<b>${attP}</b> days out of <b>${attT}</b> working days (<b>${attPct}%</b>)`:'—';
  const sonDaughter = s.gn==='Female'?'Daughter':'Son';
  const conductMap = {Good:'good character and conduct','Very Good':'very good character and conduct',Excellent:'excellent character and conduct',Satisfactory:'satisfactory conduct'};
  const certWm = logo?`<img src="${logo}" style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:300px;height:300px;object-fit:contain;opacity:0.04;pointer-events:none;z-index:0;">`:'';
  return `<div class="cert">${certWm}<div class="inner">
    ${certHeader(school,addr,phone,logo)}
    <div class="ttl">Character Certificate</div><div class="ttl-line"></div>
    <div class="no"><b>Cert. No.:</b> ${ccNo||'—'} &nbsp;&nbsp;&nbsp; <b>Date:</b> ${dt}</div>
    <div class="body">
      <p>This is to certify that <b>${s.fn}${s.ln?' '+s.ln:''}</b>, ${sonDaughter} of <b>${s.father||'—'}</b>, was a bonafide student of <b>${school}</b> during the academic year <b>${sets.year||'—'}</b>.</p><br>
      <p>During the period of study in Class <b>${s.cls||'—'}</b>, the student has shown <b>${conductMap[conduct]||'good character and conduct'}</b>. The student attended school for ${attStr}. The student has been regular and disciplined throughout the academic session.</p>
      ${remarks?`<br><p>${remarks}</p>`:''}<br>
      <p>This certificate is issued for <b>${purpose}</b> as per the request of the student/parent. We wish the student all the best in future endeavours.</p>
    </div>
    <div class="seal">
      <div class="slk"><div class="sll">Class Teacher</div></div>
      <div class="slk"><div style="font-size:14px;font-style:italic;color:#1a2e5a;margin-bottom:3px;font-family:'Playfair Display',serif;">${sets.prin||''}</div><div class="sll">Principal / Head Master</div></div>
    </div>
  </div></div>`;
}

export function buildCC(s, logo, sets, opts) {
  return `<style>${ccCSS}</style><body style="padding:0;background:#fff;">${ccBody(s, logo, sets, opts)}</body>`;
}
export function printCC(s, logo, sets, opts) {
  const w = window.open('', '_blank', 'width=820,height=1100');
  w.document.write(`<!DOCTYPE html><html><head><title>Character Certificate</title><style>${ccCSS}</style></head><body>${ccBody(s, logo, sets, opts)}<script>window.onload=()=>window.print()<\/script></body></html>`);
  w.document.close();
}

// ── Bonafide Certificate ──────────────────────────────────────────
const bcCSS = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400&family=Lato:wght@300;400;700&display=swap');
  *{box-sizing:border-box;margin:0;padding:0}
  html,body{width:210mm;min-height:297mm;background:#fff;font-family:'Lato',Arial,sans-serif;color:#1a1a2e;-webkit-print-color-adjust:exact;print-color-adjust:exact}
  .bc-page{width:210mm;height:297mm;padding:0;position:relative;background:#fff;display:flex;flex-direction:column;overflow:hidden;}
  .bc-border{position:absolute;inset:10mm;border:2.5px solid #1a2e5a;pointer-events:none;}
  .bc-border-inner{position:absolute;inset:12mm;border:1px solid #c8a96e;pointer-events:none;}
  .bc-content{padding:16mm 20mm 14mm;flex:1;display:flex;flex-direction:column;}
  .bc-header{display:flex;align-items:center;gap:18px;padding-bottom:12px;border-bottom:2px solid #1a2e5a;margin-bottom:8px;}
  .bc-logo{width:80px;height:80px;object-fit:contain;flex-shrink:0;}
  .bc-logo-placeholder{width:80px;height:80px;display:flex;align-items:center;justify-content:center;font-size:44px;flex-shrink:0;}
  .bc-school{flex:1;text-align:center;}
  .bc-school-name{font-family:'Playfair Display',serif;font-size:24px;font-weight:700;color:#1a2e5a;text-transform:uppercase;letter-spacing:1px;line-height:1.2;}
  .bc-school-sub{font-size:13px;color:#555;margin-top:4px;letter-spacing:0.5px;}
  .bc-school-addr{font-size:12px;color:#777;margin-top:3px;}
  .bc-udise{font-size:12px;color:#555;margin-top:3px;font-weight:700;}
  .bc-title-wrap{text-align:center;margin:18px 0 16px;}
  .bc-title{font-family:'Playfair Display',serif;font-size:22px;font-weight:700;color:#1a2e5a;letter-spacing:2px;text-transform:uppercase;display:inline-block;padding:7px 32px;border-top:1.5px solid #c8a96e;border-bottom:1.5px solid #c8a96e;}
  .bc-no{text-align:right;font-size:13px;color:#555;margin-bottom:14px;}
  .bc-body{font-size:15px;line-height:1.8;color:#1a1a2e;text-align:justify;}
  .bc-body p{margin-bottom:10px;}
  .bc-table{width:100%;border-collapse:collapse;margin:14px 0;}
  .bc-table td{padding:9px 14px;border:1px solid #d0d8e8;font-size:15px;vertical-align:top;}
  .bc-table td:first-child{font-weight:700;color:#1a2e5a;width:40%;background:#f4f7fb;}
  .bc-seal{display:flex;justify-content:flex-end;margin-top:auto;padding-top:10px;}
  .bc-sig{text-align:center;min-width:160px;}
  .bc-sig-line{border-top:1.5px solid #1a2e5a;padding-top:6px;font-size:13px;color:#1a2e5a;font-weight:700;letter-spacing:0.3px;}
  .bc-watermark{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);opacity:0.04;pointer-events:none;z-index:0;}
  @media print{@page{size:A4 portrait;margin:0}html,body{background:#fff;width:210mm}.bc-page{min-height:297mm}}
`;

function bcBody(s, logo, sets, opts) {
  const { bcNo, dt, purpose, cls, dob: dobOverride, admno: admnoOverride } = opts;
  const school = sets.school || 'LORD KRISHNA PUBLIC SCHOOL';
  const addr   = (sets.addr && sets.addr.trim()) ? sets.addr : 'Ishapur, Laxminagar, Mathura - 281204 (UP)';
  const prin   = sets.prin   || '';
  const udise  = sets.udise  || '';
  const phone  = sets.phone  || '';
  const yr     = sets.year   || '';
  const stuCls = cls || s.cls || '—';
  const stuAdmno = admnoOverride || s.admno || '—';

  // DOB in figures and words
  const dobRaw = dobOverride || s.dob || '';
  const dobFigures = fmtDob(dobRaw);
  const dobWords = dobRaw ? new Date(dobRaw).toLocaleDateString('en-IN', {day:'numeric',month:'long',year:'numeric'}) : '—';
  const dobDisplay = dobRaw ? `${dobFigures} (${dobWords})` : '—';

  const fullAddr = [s.addr, s.city, s.pin ? 'Pin-'+s.pin : ''].filter(v => v && v !== 'admin').join(', ') || '—';
  const sonDaughter = s.gn === 'Female' ? 'daughter' : 'son';

  const logoEl = logo
    ? `<img src="${logo}" class="bc-logo" alt="Logo">`
    : `<div class="bc-logo-placeholder">🏫</div>`;

  const watermark = logo
    ? `<img src="${logo}" class="bc-watermark" style="width:260px;height:260px;object-fit:contain;" alt="">`
    : '';

  return `<div class="bc-page">
  <div class="bc-border"></div>
  <div class="bc-border-inner"></div>
  ${watermark}
  <div class="bc-content" style="position:relative;z-index:1;">
    <div class="bc-header">
      ${logoEl}
      <div class="bc-school">
        <div class="bc-school-name">${school}</div>
        <div class="bc-school-sub">Govt. Recognised</div>
        <div class="bc-school-addr">${addr}${phone ? ' · Ph: '+phone : ''}</div>
        ${udise ? `<div class="bc-udise">UDISE Code: ${udise}</div>` : ''}
      </div>
    </div>

    <div class="bc-title-wrap">
      <div class="bc-title">Bonafide Certificate</div>
    </div>

    <div class="bc-no">
      Cert. No.: <strong>${bcNo}</strong> &nbsp;&nbsp;&nbsp; Date: <strong>${dt}</strong>
    </div>

    <div class="bc-body">
      <p>This is to certify that <strong>${s.fn||''}${s.ln?' '+s.ln:''}</strong>, ${sonDaughter} of <strong>${s.father||'—'}</strong>, is a bonafide student of this institution. The details of the student are as follows:</p>
    </div>

    <table class="bc-table">
      <tr><td>Student's Full Name</td><td>${s.fn||''} ${s.ln||''}</td></tr>
      <tr><td>Father's Name</td><td>${s.father||'—'}</td></tr>
      <tr><td>Mother's Name</td><td>${s.mother||'—'}</td></tr>
      <tr><td>Date of Birth</td><td>${dobDisplay}</td></tr>
      <tr><td>Class</td><td>${stuCls}</td></tr>
      <tr><td>Admission Number</td><td>${stuAdmno}</td></tr>
      ${s.roll ? `<tr><td>Roll Number</td><td>${s.roll}</td></tr>` : ''}
      ${s.aadhar ? `<tr><td>Aadhaar Number</td><td>${s.aadhar}</td></tr>` : ''}
      <tr><td>Academic Session</td><td>${yr||'—'}</td></tr>
      <tr><td>Permanent Address</td><td>${fullAddr}</td></tr>
    </table>

    <div class="bc-body">
      <p>This certificate is issued for the purpose of <strong>${purpose}</strong> as per the request of the student / parent / guardian.</p>
      <p>We wish the student all the best in future endeavours.</p>
    </div>

    <div class="bc-seal">
      <div class="bc-sig">
        <div style="font-size:17px;font-style:italic;color:#1a2e5a;margin-bottom:5px;font-family:'Playfair Display',serif;">${prin}</div>
        <div class="bc-sig-line">Principal / Head Master</div>
      </div>
    </div>

    <div style="text-align:center;margin-top:20px;font-size:11px;color:#aaa;letter-spacing:0.5px;">
      ${school} · ${addr}
    </div>
  </div>
</div>`;
}

export function buildBonafide(s, logo, sets, opts) {
  return `<style>${bcCSS}</style><body style="padding:0;background:#fff;">${bcBody(s, logo, sets, opts)}</body>`;
}

export function printBonafide(s, logo, sets, opts) {
  const w = window.open('', '_blank', 'width=820,height=1100');
  w.document.write(`<!DOCTYPE html><html><head><title>Bonafide Certificate</title><style>${bcCSS}</style></head><body>${bcBody(s, logo, sets, opts)}<script>window.onload=()=>window.print()<\/script></body></html>`);
  w.document.close();
}

// ── Teacher ID Card ───────────────────────────────────────────────
function buildTeacherCardFront(t, photo, logo, phone, year, prin, theme) {
  const th = THEMES[theme] || THEMES.blue;

  const photoEl = photo
    ? `<img src="${photo}" style="width:100%;height:100%;object-fit:cover;display:block;">`
    : `<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:#e8edf5;font-size:44px;font-weight:900;color:#aab4cc;font-family:sans-serif;">${((t.fn||'?')[0]).toUpperCase()}</div>`;

  let qrEl = '';
  try {
    const qd = encodeURIComponent(`${t.fn||''} ${t.ln||''}\nSubject:${t.su||''}\nClass:${t.cls||''}\nEmpID:${t.empId||''}\nPh:${t.ph||''}`);
    qrEl = `<img src="https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${qd}&margin=3&ecc=M" width="135" height="135" style="display:block;" alt="QR"/>`;
  } catch(e){}

  const drow = (label, val) =>
    `<div style="margin-bottom:16px;"><div style="font-size:13px;color:#444;font-family:'Roboto',sans-serif;">${label}</div><div style="font-size:17px;font-weight:700;color:#111;font-family:'Montserrat',sans-serif;line-height:1.2;">${val}</div></div>`;

  const logoEl = logo
    ? `<img src="${logo}" style="width:86px;height:86px;object-fit:contain;display:block;">`
    : `<div style="width:86px;height:86px;display:flex;align-items:center;justify-content:center;font-size:48px;">🏫</div>`;

  return `<div style="width:${CW}px;height:${CH}px;border-radius:10px;overflow:hidden;box-shadow:0 16px 48px rgba(0,0,0,.4);display:flex;flex-direction:column;background:${th.bg};font-family:'Montserrat',sans-serif;">
<style>${GFONT} * { margin:0; padding:0; box-sizing:border-box; }</style>
<div style="background:#fff;padding:16px 16px;display:flex;align-items:center;gap:14px;border-bottom:3px solid ${th.h1};">
  ${logoEl}
  <div style="width:2px;height:72px;background:#ddd;flex-shrink:0;"></div>
  <div style="flex:1;">
    <div style="font-size:26px;font-weight:900;color:${th.h1};font-family:'Montserrat',sans-serif;text-transform:uppercase;line-height:1.05;letter-spacing:0.3px;">Lord Krishna</div>
    <div style="font-size:26px;font-weight:900;color:${th.h1};font-family:'Montserrat',sans-serif;text-transform:uppercase;line-height:1.05;letter-spacing:0.3px;margin-bottom:6px;">Public School</div>
    <div style="font-size:14px;color:${th.h1};font-family:'Cormorant Garamond',serif;font-weight:600;letter-spacing:0.4px;">Govt. Recognised</div>
    <div style="font-size:14px;color:${th.h1};font-family:'Cormorant Garamond',serif;font-weight:600;letter-spacing:0.4px;">Ishapur, Laxminagar, Mathura</div>
  </div>
</div>
<div style="background:${th.bg};padding:8px 0;text-align:center;border-bottom:1px solid rgba(0,0,0,.08);">
  <span style="font-size:15px;font-weight:600;color:#333;font-family:'Montserrat',sans-serif;letter-spacing:1.5px;">Teacher ID Card</span>
</div>
<div style="background:${th.h1};padding:10px 14px;text-align:center;">
  <span style="font-size:20px;font-weight:300;color:#fff;font-family:'Raleway',sans-serif;letter-spacing:2px;text-transform:uppercase;">${t.fn||'Teacher'} ${t.ln||''}</span>
</div>
<div style="flex:1;display:flex;background:${th.bg};min-height:0;">
  <div style="width:165px;flex-shrink:0;padding:14px 10px 14px 14px;display:flex;flex-direction:column;align-items:flex-start;">
    <div style="width:155px;height:190px;overflow:hidden;border:3px solid ${th.h1};border-radius:6px;flex-shrink:0;box-shadow:0 4px 12px rgba(0,0,0,.2);">${photoEl}</div>
    <div style="flex:1;min-height:8px;"></div>
    ${qrEl}
  </div>
  <div style="flex:1;padding:16px 14px 14px;display:flex;flex-direction:column;min-width:0;">
    ${t.qual ? drow('Qualification:', t.qual) : ''}
    ${t.empId ? drow('Emp. ID:', t.empId) : ''}
    ${drow('Designation:', t.desig||'Teacher')}
    ${t.ph ? drow('Phone:', t.ph) : ''}
    ${t.blood ? drow('Blood Group:', `<span style="color:#c0392b;">${t.blood}</span>`) : ''}
    ${drow('Validity:', year||'2026-27')}
    <div style="margin-top:auto;text-align:right;padding-top:6px;">
      <div style="font-size:24px;font-style:italic;color:${th.h1};font-family:'Georgia',serif;">${prin||'__________'}</div>
      <div style="font-size:12px;color:#555;font-family:'Roboto',sans-serif;margin-top:3px;">Principal</div>
    </div>
  </div>
</div>
<div style="background:${th.h1};padding:8px 14px;text-align:center;">
  <span style="font-size:12px;color:rgba(255,255,255,.85);font-family:'Roboto',sans-serif;letter-spacing:1px;font-weight:500;">www.lkpschool.in</span>
</div>
</div>`;
}

function buildTeacherCardBack(t, logo, phone) {
  const infoRow = (label, val) =>
    `<div style="display:flex;align-items:baseline;gap:6px;margin-bottom:9px;">
      <div style="font-size:13px;color:#222;font-family:'Roboto',sans-serif;white-space:nowrap;">${label}</div>
      <div style="font-size:14px;font-weight:700;color:#000;font-family:'Montserrat',sans-serif;flex:1;line-height:1.4;">${val}</div>
    </div>`;

  return `<div style="width:${CW}px;height:${CH}px;border-radius:10px;overflow:hidden;font-family:'Montserrat',sans-serif;box-shadow:0 16px 48px rgba(0,0,0,.45);display:flex;flex-direction:column;background:#fff;">
<style>${GFONT}</style>
<div style="padding:16px 16px 12px;display:flex;flex-direction:column;">
  ${t.blood ? infoRow('Blood Group :', `<span style="font-size:15px;color:#c0392b;">${t.blood}</span>`) : ''}
  ${t.ph ? infoRow('Contact No. :', t.ph) : ''}
  ${t.em ? infoRow('Email :', t.em) : ''}
  ${t.doj ? infoRow('Date of Joining :', new Date(t.doj).toLocaleDateString('en-IN')) : ''}
  <div style="font-size:13px;font-weight:700;color:#000;text-decoration:underline;margin:14px 0 7px;font-family:'Roboto',sans-serif;">Rules to be followed :</div>
  <div style="font-size:11.5px;color:#111;line-height:1.85;font-family:'Roboto',sans-serif;">
    <div style="margin-bottom:2px;">• This card must be carried at all times within school premises.</div>
    <div style="margin-bottom:2px;">• If found, please return this card to the school office.</div>
    <div style="margin-bottom:2px;">• Loss of ID card must be reported to the principal immediately.</div>
    <div>• Misuse of this card is a punishable offence.</div>
  </div>
</div>
<div style="flex:1;background:#fff;"></div>
<div style="height:150px;background:#fff;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;flex-shrink:0;overflow:hidden;">
  ${logo ? `<img src="${logo}" style="height:100px;object-fit:contain;opacity:0.45;">` : `<div style="font-size:80px;opacity:0.35;line-height:1;">🏫</div>`}
  <div style="font-size:17px;font-weight:800;color:#ccc;font-family:'Montserrat',sans-serif;letter-spacing:1px;text-transform:uppercase;">Lord Krishna Public School</div>
</div>
<div style="background:#111;padding:14px 14px;text-align:center;flex-shrink:0;">
  <div style="font-size:12px;color:#ddd;font-family:'Roboto',sans-serif;line-height:1.7;">Ishapur, Laxminagar, Mathura - 281204 (UP) India</div>
  <div style="font-size:12px;color:#aaa;font-family:'Roboto Mono',monospace;margin-top:4px;">Phone: +91 9997360040, +91 8650616990</div>
</div>
</div>`;
}

export function buildTeacherCard(t, photo, logo, phone, year, prin, theme) {
  return buildTeacherCardFront(t, photo, logo, phone, year, prin, theme);
}

export { buildTeacherCardBack };

export function printTeacherCard(t, photo, logo, phone, year, prin, theme) {
  const front = buildTeacherCardFront(t, photo, logo, phone, year, prin, theme);
  const back  = buildTeacherCardBack(t, logo, phone);
  const w = window.open('', '_blank', 'width=820,height=620');
  w.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><style>${printCSS(true)}</style></head><body>
    <div class="pair">
      <div class="side"><div class="side-label">Front</div><div class="card-wrap">${front}</div></div>
      <div class="side"><div class="side-label">Back</div><div class="card-wrap">${back}</div></div>
    </div>
    <script>window.onload=()=>window.print()<\/script></body></html>`);
  w.document.close();
}
